import { UserProfileInline } from "app/components/UserProfileInline";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { toast } from 'react-toastify';
import useQueryString from "utils/hooks/useQueryString";

export const BookDebateForm = ({
    className = "", placeholder = "", mode = "create", comment = null, rootId = null, useCancel = false, page = null, onCancel = (f) => f, setPage = (f) => f }) => {
    const queryClient = useQueryClient();
    const auth = useSelector(state => state.auth);
    const { isbn } = useParams();
    const [content, setContent] = useState("");

    const queryParams = useQueryString();

    const requestData = useMemo(() => {
        const paramJson = { page: 0, sort: 'id,desc', isbn };
        return { ...paramJson, ...queryParams };
    }, [queryParams, isbn]);

    useEffect(() => {
        if (mode === 'modify' && comment) setContent(comment.content);
    }, [comment, mode])


    // -------------- 저장
    const commentStoreMutate = useMutation({
        mutationFn: (data) => Api.post(`/api/book/${data.isbn}/debate/store`, data),
        onSuccess: (res) => {
            setContent("");
            onCancel();

            if (rootId === null) return queryClient.invalidateQueries({ queryKey: ['book/debate/list', requestData] });
            console.log(rootId);
            queryClient.invalidateQueries({ queryKey: ['book/debate/sub/list', rootId, page] });
            setPage();
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    })

    const onSave = (e) => {
        e.preventDefault();
        if ([...content.replaceAll(" ", "")].length < 10) return toast.error("10자 이상 작성해주세요.");
        if (commentStoreMutate.isPending) return;
        // 이건 뭔가 자못된겨
        if (mode !== 'create' && comment === null) return;

        const storeData = { id: null, content, isbn };
        if (mode === 'modify') {
            storeData.id = comment.id;
        } else if (mode === 'reply') {
            storeData.replyId = comment.id;
        }
        commentStoreMutate.mutate(storeData);
    };

    return (
        <div className={`input_wrap  ${className} `}>
            {mode === "create" && auth.authenticated && <UserProfileInline id={auth.id} name={auth.name} image={auth.image} />}
            <textarea placeholder={placeholder} rows="3" name="content" value={content} onChange={(e) => setContent(e.target.value)}></textarea>
            <button type="button" className="btn _blue" onClick={onSave}>
                저장
            </button>
            {useCancel && <button className="btn _xsm _gray btn_cancel" onClick={onCancel}>취소</button>}
        </div>
    );
};